module.exports = __webpack_public_path__ + "img/24.drop-light.ff7fde83.svg";